import React from 'react';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {EvBatteryPerformanceStatus} from '@di-shared/features/home/kr/ev-battery/monitor/const';

interface EvBatteryPerformanceBottomSheetProps {
  brandName: string;
  onExit: () => void;
  evBatteryPerformanceStatus: EvBatteryPerformanceStatus;
}

function EvBatteryPerformanceBottomSheetNa({evBatteryPerformanceStatus, ...props}: EvBatteryPerformanceBottomSheetProps) {
  switch (evBatteryPerformanceStatus) {
    case EvBatteryPerformanceStatus.GOOD:
      return <Good {...props} />;
    case EvBatteryPerformanceStatus.NORMAL:
      return <Normal {...props} />;
    default:
      props.onExit();
      return <></>;
  }
}

export default EvBatteryPerformanceBottomSheetNa;

function Good({brandName, onExit}: Omit<EvBatteryPerformanceBottomSheetProps, 'evBatteryPerformanceStatus'>) {
  const {t} = useInferableTranslation();
  return (
    <div className="bottom_sheet bottom_sheet_battery">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('ctn_evb_performance_status_btm_sht_title_eu')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('ctn_home_close')}
          onClick={onExit}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="battery_banner_box">
            <div className="text_area">
              <span className="ic ic_filled_good_face"></span>
              <p className="desc">{t('msg_evb_performance_status_btm_sht_good_result_eu')}</p>
            </div>
            <div className="img_box">
              <ImageSelector
                kiaLightSrc={() => import('@di-shared/assets/img/home/battery_performance_good_light.png')}
                kiaDarkSrc={() => import('@di-shared/assets/img/home/battery_performance_good.png')}
                hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/battery_performance_good_light.png')}
                hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/battery_performance_good.png')}
                genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/battery_performance_good_light.png')}
                genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/battery_performance_good.png')}
                className="image"
                alt=""
                width="170"
                height="98"
              />
            </div>
          </div>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_evb_performance_status_btm_sht_good_desc_01_eu')}
          </p>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_evb_performance_status_btm_sht_good_desc_02_eu')}
          </p>
        </div>
      </div>
    </div>
  );
}

function Normal({brandName, onExit}: Omit<EvBatteryPerformanceBottomSheetProps, 'evBatteryPerformanceStatus'>) {
  const {t} = useInferableTranslation();
  return (
    <div className="bottom_sheet bottom_sheet_battery">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('ctn_evb_performance_status_btm_sht_title_eu')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('ctn_home_close')}
          onClick={onExit}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="battery_banner_box">
            <div className="text_area">
              <span className="ic ic_filled_normal_face"></span>
              <p className="desc">{t('msg_evb_performance_status_btm_sht_normal_result_eu')}</p>
            </div>
            <div className="img_box">
              <ImageSelector
                kiaLightSrc={() => import('@di-shared/assets/img/home/battery_performance_normal_light.png')}
                kiaDarkSrc={() => import('@di-shared/assets/img/home/battery_performance_normal.png')}
                hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/battery_performance_normal_light.png')}
                hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/battery_performance_normal.png')}
                genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/battery_performance_normal_light.png')}
                genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/battery_performance_normal.png')}
                className="image"
                alt=""
                width="170"
                height="98"
              />
            </div>
          </div>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_evb_performance_status_btm_sht_normal_desc_01_eu')}
          </p>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_evb_performance_status_btm_sht_normal_desc_02_eu')}
          </p>
        </div>
      </div>
    </div>
  );
}
